import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-72403f0a")

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_icon_loader = _resolveComponent("icon-loader")!

  return (_openBlock(), _createBlock(_component_icon_loader, { class: "SLoader" }))
})